import { GameType, Hero } from '../types';

import meleeHeroes from './meleeHeroes.json'
import ulimateHeroes from './ultimateHeroes.json'


export const getHeroData = (type: GameType) => {
    var heroes;
    switch(type){
        case GameType.Ultimate:
            heroes = ulimateHeroes;
            break;
        default:
            heroes =  meleeHeroes;
            break;
    }
    return heroes;
}

export const getHeroImage = (type: GameType, hero:Hero) : any => {
    const heroImagePath = `./${getGameFolderName(type)}`;
    const context = require(`${heroImagePath}/${hero.Image}`);

    return context;
}

export const getHeroBasedOnName = (name :string, gameType : GameType) : Hero => {
    const heroList: any = getHeroData(gameType);
    let foundHero : any = undefined;
    for(var key in heroList){
        var hero: Hero = heroList[key];
        if (hero.Name === name) {
            foundHero = hero;
            break;
        }
    }
    if(!foundHero){
        throw new Error(`'${name}' not found `)
    }
    return foundHero;
}

const getGameFolderName = (type:GameType) => {
    switch(type){
        case GameType.Ultimate:
            return 'ultimateHeroesImages'
        default:
            return 'meleeHeroesImages'
    }
}
